export const INITIALIZE = '[Invite Users] Initialize';
export const DESTROY = '[Invite Users] Destroy';
export const LOAD_ORGANISATIONS = '[Invite Users] Load Organisations';
export const LOAD_ORGANISATIONS_DONE = '[Invite Users] Load Organisations Done';
export const SET_ERROR_MESSAGE = '[Invite Users] Set Error Message';
export const UPDATE_SELECTED_ORGANISATION_ID = '[Invite Users] Update Selected Organisation ID';
export const ADD_USER = '[Invite Users] Add User';
export const REMOVE_USER = '[Invite Users] Remove User';
export const SUBMIT_INVITE = '[Invite Users] Submit Invite';
export const SUBMIT_INVITE_DONE = '[Invite Users] Submit Invite Done';